var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data !== null
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container container--mobile" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("br"),
                  _vm._v(" "),
                  _c("Pagination", {
                    attrs: { numberOfDots: 4, numberOfVisitedDots: 2 }
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.screening.confirmNumberText)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "phone-number-wrapper" }, [
                    _c("div", { staticClass: "phone-number-prefix" }, [
                      _vm._v(_vm._s(_vm.prefix))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phoneNumber,
                          expression: "phoneNumber"
                        }
                      ],
                      staticClass:
                        "form-control form-control-lg form-control-block phone-number-input",
                      attrs: {
                        id: "phone-number-input",
                        type: "text",
                        name: "phoneNumber",
                        maxlength: _vm.phoneLength
                      },
                      domProps: { value: _vm.phoneNumber },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.phoneNumber = $event.target.value
                          },
                          function($event) {
                            return _vm.enforceNumbers()
                          }
                        ],
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.verifyPhone()
                        }
                      }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("div", { staticClass: "margin-top-15" }),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("alert", [
                    _vm._v("Något gick fel, vänligen försök igen!")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-lg btn-block",
                      attrs: { disabled: !_vm.isLengthValid },
                      on: {
                        click: function($event) {
                          return _vm.verifyPhone()
                        }
                      }
                    },
                    [_vm._v("Skicka kod")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrapper margin-top-75" }, [
      _c("h2", { staticClass: "text-left text-primary-fh" }, [
        _vm._v("Bekräfta/ändra ditt telefonnummer")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-danger alert-validation" }, [
      _c("strong", [
        _vm._v("Numret kunde ej valideras, kontrollera och försök igen.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-408b65a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408b65a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmNumber.vue
// module id = null
// module chunks = 